import {init} from '@sentry/browser'

/*
 * Browser-side Sentry init for both routers.
 *
 * Next requires this module from the client entry (`app-next.js` and `next.js` alike) before it
 * hydrates, which is the only hook that runs for App Router and Pages Router pages.
 */
if (process.env.sentryDSN) {
  init({
    dsn: process.env.sentryDSN,
    environment: process.env.NODE_ENV || 'development',
    ...(process.env.NEXT_PUBLIC_COMMIT_ID ? {release: process.env.NEXT_PUBLIC_COMMIT_ID} : {}),
  })
}
